import React from 'react';

import Lottie from 'lottie-react';

import data from '@pkg/lotties/generation-logo-1.json';

import './GenerationLogo.scss';

export function GenerationLogoOne() {
    const animationData = data;
    const rendererSettings = {
        preserveAspectRatio: 'xMidYMid slice',
    };

    return (
        <div className="generation-logo">
            <Lottie loop={false} autoplay={true} animationData={animationData} rendererSettings={rendererSettings} />
        </div>
    );
}
